
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AddWebsite from "./pages/AddWebsite";
import BackupHistory from "./pages/BackupHistory";
import Restore from "./pages/Restore";
import Profile from "./pages/Profile";
import WordPressPlugin from "./pages/WordPressPlugin";
import PluginTesting from "./pages/PluginTesting";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";

const queryClient = new QueryClient();

// Always use HashRouter for better compatibility with shared hosting environments
const Router = HashRouter;

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Router>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/add-website" element={<ProtectedRoute><AddWebsite /></ProtectedRoute>} />
            <Route path="/backup-history/:websiteId" element={<ProtectedRoute><BackupHistory /></ProtectedRoute>} />
            <Route path="/restore/:websiteId/:backupId" element={<ProtectedRoute><Restore /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/wordpress-plugin" element={<ProtectedRoute><WordPressPlugin /></ProtectedRoute>} />
            <Route path="/plugin-testing" element={<ProtectedRoute><PluginTesting /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </TooltipProvider>
      </AuthProvider>
    </Router>
  </QueryClientProvider>
);

export default App;
